import ezpay from './ezpay';

export default {
  ezpay,
};

